module.exports = __webpack_public_path__ + "static/media/snow.30ab9124.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/snow.svg
// module id = 2574
// module chunks = 2